window.calculatePriceFifty = (quantity) => {
    const modal = document.getElementById('modal-showModalFifty');
    const resultPrice = document.getElementById('fifty-price-result');
    const size = modal.querySelector('#fifty-size').getElementsByTagName('input')[0].checked; //checked = 33 
    const fiftyChoices = modal.querySelectorAll('.fifty-choice-content.completed');

    let initialPrice = priceSupp = newPrice = 0;
    let sizePrice = [];
    sizePrice[0] = modal.querySelector('#fifty-size').getAttribute('data-price-29')
    sizePrice[1] = modal.querySelector('#fifty-size').getAttribute('data-price-33')

    initialPrice = (size) ? sizePrice[1] : sizePrice[0];

    if (fiftyChoices.length > 0) {
        for (let index = 0; index < fiftyChoices.length; index++) {
            priceSupp += parseFloat(fiftyChoices[index].getAttribute('data-price'));
        }
    }

    newPrice = (parseFloat(initialPrice) + parseFloat(priceSupp)) * quantity;

    resultPrice.innerHTML = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    }).format(newPrice)
}


window.addEventListener('calculatePriceFifty', event => {
    let quantity = document.getElementById('modal-showModalFifty').querySelector('.quantity').getAttribute('data-quantity');

    calculatePriceFifty(quantity);
})